export const BASE_URL = '___base_url___';
export const BASE_API_URL = '___api_url___';
export const APP_TITLE = 'PITAGORA';
